// extracted by mini-css-extract-plugin
module.exports = {"link":"TagLink_link__c1UIA"};